@if (title) {
  <div class=" block-image algolia-content-header"
       style="background-image: url('/assets/images/top_image.webp');">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center"><h1>{{ title }}</h1></div>
      </div>
    </div>
  </div>
}
